import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';
import usePrequal from '../../prequal/usePrequal';

const fetcher = async (key) => {
  const res = await capsFetcher({
    url: key,
  });
  return res.data;
};

const useCapsUser = (options) => {
  const { data: prequal } = usePrequal();
  return useSWRImmutable(
    `/users/${prequal.capsId}`,
    fetcher,
    { suspense: true, ...options },
  );
};

export default useCapsUser;
